import { AuthFormMode } from '@/store/authFormMode/types';
import { CalmAuthMethods } from '@/utils/privacyCookies';

export const getAuth0Endpoint = (authMethod: CalmAuthMethods, mode: AuthFormMode = 'signup'): string => {
	return `${mode}-with-${authMethod}`;
};
